/* @flow */

import * as React from 'react';
import { useHistory } from 'react-router-dom';

import { trackGAPage } from 'src/shared/core/service/tracking/gaService';

export default function usePageTracking() {
  const history = useHistory();

  React.useEffect(() => {
    history.listen(({ pathname }) => trackGAPage(pathname));
  }, []);
}
